var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14H5C3.34315 14 2 12.6569 2 11V5C2 3.34315 3.34315 2 5 2H8.5C8.77614 2 9 2.22386 9 2.5C9 2.77614 8.77614 3 8.5 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H9.5C9.77614 13 10 13.2239 10 13.5C10 13.7761 9.77614 14 9.5 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3786 5.15638C12.1701 4.94787 11.8321 4.94787 11.6236 5.15638C11.4151 5.36489 11.4151 5.70295 11.6236 5.91146L13.1781 7.466L5.53392 7.466C5.23904 7.466 5 7.70505 5 7.99992C5 8.2948 5.23904 8.53384 5.53392 8.53384H13.1783L11.6236 10.0885C11.4151 10.2971 11.4151 10.6351 11.6236 10.8436C11.8321 11.0521 12.1701 11.0521 12.3786 10.8436L14.8447 8.37754C14.9074 8.31489 14.9512 8.24054 14.9762 8.16153C14.9882 8.12364 14.9961 8.08392 14.9994 8.0429C15.0012 8.01978 15.0016 7.99657 15.0004 7.97342C14.9968 7.89927 14.9781 7.82909 14.9472 7.76591C14.9331 7.73692 14.9161 7.70895 14.8964 7.68239C14.8793 7.65923 14.8603 7.63751 14.8397 7.61743L12.3786 5.15638Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.ee9bd5c87e66949999a170dad89cd619.svg";
export { ForwardRef as ReactComponent };